import { findNumbers, parsePhoneNumberFromString } from "libphonenumber-js";
import _ from "lodash";
import { userHasRight } from "../../../framework";
import * as z from "../../../framework";
import K_Editor from "../templates/K_Editor";
import { ComponentOptions, RightLockable } from "./component";
import { TemplateComponent } from "./templateComponent";

export interface EditorOptions extends ComponentOptions {
    bsc?: string;
    requiredRight?: string;
}

export class Editor extends TemplateComponent {

    options: EditorOptions & RightLockable;

    constructor(options: EditorOptions) {
        super(K_Editor, options);
    }

    create() {
        $(`#${this.id}`).kendoEditor({
            tools: [
                {
                    name: "bold",
                    tooltip: z.ll("Bold")
                },
                {
                    name: "italic",
                    tooltip: z.ll("Italic")
                },
                {
                    name: "underline",
                    tooltip: z.ll("Underline")
                },
                {
                    name: "insertUnorderedList",
                    tooltip: z.ll("InsertUnorderedList")
                },
                {
                    name: "insertOrderedList",
                    tooltip: z.ll("InsertOrderedList")
                },
                {
                    name: "createLink",
                    tooltip: z.ll("InsertHyperlink")
                },
                {
                    name: "phoneNumberLink",
                    template: `<a title="${z.ll("PhoneNumberLinkTooltip")}" class="k-tool"><i class="fas fa-phone k-tool-icon k-icon" style="font-size: 12px;"/><a>`,
                    exec: function () {
                        var editor = $(this).data("kendoEditor");
                        var selection = editor.getSelection();
                        var defaultCountryCode = z.user.companyData.Settings ?
                            z.user.companyData.Settings.DefaultLocale.split("-")[1].toUpperCase()
                            : "US";

                        editor.trigger("execute");

                        if (selection && selection.anchorNode && selection.anchorNode.nodeValue) {
                            var phoneNumbers = findNumbers(selection.anchorNode.nodeValue, defaultCountryCode);

                            _.forEach(phoneNumbers, (foundPhoneNumber) => {
                                var offsetCheck = (foundPhoneNumber.startsAt <= selection.anchorOffset && foundPhoneNumber.endsAt >= selection.anchorOffset)
                                    || (selection.focusOffset <= foundPhoneNumber.startsAt && selection.anchorOffset >= foundPhoneNumber.endsAt);

                                if (offsetCheck) {
                                    var range = editor.createRange();
                                    range.setStart(selection.anchorNode, foundPhoneNumber.startsAt);
                                    range.setEnd(selection.anchorNode, foundPhoneNumber.endsAt);
                                    editor.selectRange(range);
                                    var selectedHtml = editor.selectedHtml();
                                    var phoneNumber = parsePhoneNumberFromString(selectedHtml, defaultCountryCode);

                                    editor.exec("insertHTML", {
                                        value: `<a href="tel:${phoneNumber.number}">${selectedHtml}</a>`
                                    });
                                    return;
                                }
                            });
                        }
                    }
                },
                {
                    name: "unlink",
                    tooltip: z.ll("RemoveLink")
                }
            ]
        });
    }
}
